/* eslint-disable no-console */

import { LegalPriceRequest } from '../types/types';

const getInventoryPriceIds = (
  inventoriesValue?: Array<{ inventoryPriceId?: number | string }> | null
): string[] =>
  (inventoriesValue ?? [])
    .map((item) => item?.inventoryPriceId)
    .filter((id): id is number | string => id !== undefined && id !== null)
    .map((id) => String(id));

export const getValidNumber = (value: unknown): number | undefined => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : undefined;
};

export const buildLegalPriceRequest = (
  storeNumber: string | null,
  inventoriesValue?: Array<{ inventoryPriceId?: number | string }> | null
): LegalPriceRequest => {
  const inventoryPriceIds = getInventoryPriceIds(inventoriesValue);

  return {
    storeNumber: storeNumber || '',
    inventoryPriceId: inventoryPriceIds,
  };
};

export const getLegalPriceKey = (
  inventoriesValue?: Array<{ inventoryPriceId?: number | string }> | null
): string => getInventoryPriceIds(inventoriesValue).sort().join('|');

export const deriveMaximumAllowedTerm = (
  totalCost: string,
  currentAgreementRate: string | number,
  itemPriceMaxTerm?: number
): number | undefined => {
  const normalizedTotalCost = getValidNumber(totalCost);
  const normalizedAgreementRate = getValidNumber(currentAgreementRate);
  const normalizedItemPriceMaxTerm = getValidNumber(itemPriceMaxTerm);

  if (
    normalizedTotalCost === undefined ||
    normalizedAgreementRate === undefined ||
    normalizedAgreementRate === 0
  ) {
    return normalizedItemPriceMaxTerm;
  }

  const legalMaxTerm = Math.floor(
    normalizedTotalCost / normalizedAgreementRate
  );

  if (normalizedItemPriceMaxTerm === undefined) {
    return legalMaxTerm;
  }

  return legalMaxTerm >= normalizedItemPriceMaxTerm
    ? legalMaxTerm
    : normalizedItemPriceMaxTerm;
};
